import { createEvent } from 'effector';

export const putZoom9HexagonsEv = createEvent();

export const updateZoom9HexagonsBy10Ev = createEvent();

export const resetZoom9ByMetricsEv = createEvent();

export const putMutated9HexagonsEv = createEvent();

export const putFilteredZoom9HexagonsEv = createEvent();

export const filterZoom9GradientEv = createEvent();

export const putZoom9StartHexagonsEv = createEvent();

export const sendWsGetRBPEv = createEvent();

export const mutateZoom9PeopleEv = createEvent();

export const putZoom9StartPeopleDataEv = createEvent();
